import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BoldPortfolio from './pages/BoldPortfolio';
import SignalPortfolio from './pages/SignalPortfolio';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BoldPortfolio />} />
          <Route path="/signal" element={<SignalPortfolio />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
